import React from 'react';
import { Col, Row } from 'reactstrap';
import YourApiKey from '../YourApiKey/YourApiKey';
import ApiCreditsUsed from '../ApiCreditsUsed/ApiCreditsUsed';
import DebugToolWidget from '../../../../components/DebugToolWidget/DebugToolWidget';
import DebugToolWidgetResults from '../../../../components/DebugToolWidget/DebugToolWidgetResults';
import RateLimitUpgradeModal from '../../../../shared/components/Modals/UpgradeModals/RateLimitUpgradeModal';

const ApiDetailsTabContent = ({ planApiKey, currentOrg }) => {
  return (
    <>
      <RateLimitUpgradeModal />
      <Row>
        <Col md={6}>
          <YourApiKey planApiKey={planApiKey} />
        </Col>
        <Col md={6}>
          <ApiCreditsUsed currentCycleInformation={currentOrg} />
        </Col>
      </Row>
      <Row>
        <Col md={12}>
          <DebugToolWidget />
          <DebugToolWidgetResults />
        </Col>
      </Row>
    </>
  )
}

export default ApiDetailsTabContent;
